module.exports = __webpack_public_path__ + "static/media/google-doc-thumbnail.a61bdcb7.jpg";